export const Brand = () => (
  <div className="arx-corporate-header__brand">
    <span className="arx-corporate-header__brand-mark" aria-hidden="true">
      A
    </span>

    <div className="arx-corporate-header__brand-copy">
      <span className="arx-corporate-header__brand-name">ARANOX</span>
      <span className="arx-corporate-header__platform-name">
        Digital Platform
      </span>
    </div>
  </div>
);
